import { HttpRequestData, httpUtil } from '@esg/framework';
import { getEnv } from '@esg/shared';

interface GetOverviewSaleRequest extends HttpRequestData {
    readonly startTime: string;
    readonly endTime: string;
    readonly branchId?: string;
}

export interface GetOverviewSaleResponseItem {
    currentSaleCount: number;
    pastSaleCount: number;
    unpaidCount: number; 
    cancelledCount: number;
}

export const getOverviewSale = httpUtil.createHttpRequestMeta<
    GetOverviewSaleRequest,
    GetOverviewSaleResponseItem
>({
    baseUrl: () => getEnv().AGENCY_SERVER,
    path: '/api/v1/sales/overview',
    method: 'GET',
    authentication: 'bearer',
});